module.exports = __webpack_public_path__ + "img/landscape-404.312d0d65.jpg";